import FaqImg from 'assets/icons/faq.svg';
import InfoImg from 'assets/icons/info.svg';

import SendMoneyImg from 'assets/faqs/send_money.png';
import RewardsImg from 'assets/icons/rewards.svg';
import LendingPartnerImg from 'assets/faqs/lending_partner.png';
import CreditImg from 'assets/icons/credit.svg';
import BillsImg from 'assets/icons/bills.svg';
import CCBillPayment from 'assets/faqs/cc_bill_payment.png';
import ONDC from 'assets/icons/ondc.svg';

import TransactionIssuesImg from 'assets/faqs/transaction_issues.png';
import BharatBillImg from 'assets/icons/bills_recharge.png';
import CashMax from 'assets/bottom-tabs/bank.svg';
import { voucherFaqs } from './assetConstants';
import { ChangeHistory, nativeHandler } from 'utils';
import BlueQr from 'assets/icons/blue-qr.svg';

import AuCCImg from 'assets/icons/au-cc.png';
import VasImg from 'assets/icons/vas-faq.png';

const openUrl = (url) => () => {
	nativeHandler.openURL(url);
};

export const Url = ({ url, alternateText }) => {
	return (
		<span className="text-case-default font-heavy underline" onClick={openUrl(url)}>
			{alternateText ? alternateText : url}
		</span>
	);
};

const openCharges = () => {
	ChangeHistory('push', '/charges');
};

const faqs = (limits = {}, lender = '', { showCoachMarks } = {}) => ({
	'About bharatpe': {
		img: InfoImg,
		faqs: [
			{
				title: `What is bharatpe?`,
				content: (
					<>
						<p>
							bharatpe is a new way to pay, and makes spending easy. In collaboration with lending partners, you can spend
							now and pay next month. A line of credit is offered through bharatpe by RBI Registered lenders (after
							necessary checks and KYC completion) which can be used anytime, anywhere to purchase goods and services -
							either by scanning a QR , sending money directly to your bank account, making utility bill payments or
							availing a personal loan from the assigned bharatpe limit. When it's time to pay your bill, you can clear
							your dues in one go, or convert to an Equated Monthly Installment (EMI) with tenure of your choice. You
							can also earn exciting cashback and rewards. Get started now!
						</p>
					</>
				),
			},
			{
				title: `How can I use bharatpe?`,
				content: (
					<>
						<p>bharatpe can be used for both online and offline transactions - spend anytime, anywhere! </p>
						<p className="mr-t-5">• By scanning a QR, you can pay millions of BharatPe merchants directly.</p>
						<p className="mr-t-5">• Avail a personal loan for your financial needs.</p>
						<p className="mr-t-5">
							• Send money to your own bank account on 1 month free interest rate from your assigned credit limit.
						</p>
						<p className="mr-t-5">• Make utility bill payments</p>
						<p className="mr-t-5">
							• We may from time to time modify existing products, features, or services, or otherwise introduce new
							features or services on or through bharatpe
						</p>
					</>
				),
			},
		],
	},
	'Credit Limit': {
		img: CreditImg,
		faqs: [
			{
				title: `How do I sign up for bharatpe?`,
				content: `You can sign up for bharatpe by verifying your mobile number and then completing your KYC using PAN and Aadhaar number or any other information as required by the RBI registered lender`,
			},
			{
				title: `What is the maximum credit limit I can get?`,
				content: `You can get a credit limit of up to ₹10 lakhs post completion of full KYC and meeting the required criteria as maybe determined by RBI registered lenders. This limit may increase if you continue using bharatpe and making timely repayments.`,
			},
			{
				title: 'How does my credit  limit increase?',
				content:
					'The credit limit is increased basis multiple parameters such as transactions, timely repayments, credit bureau score, lending partners approval etc. we typically review the credit limit after 6 months of usage, basis the spending and repayments. ',
			},
			{
				title: 'Are there any other transaction limits on bharatpe?',
				content:
					'Basis certain criteria, you will have different sub limits on each mode - QR, Send Money, bharatpe loans. The same are visible in the transaction details of your profile.',
			},
			{
				title: 'Is the bharatpe credit limit reflected in my credit bureau?',
				content:
					'bharatpe credit limit is a loan facility sanctioned by our RBI registered lending partners. Similar to other loan facilities, bharatpe credit limit will be reflected as loan in the credit bureau.',
			},
			{
				title: 'Will my credit score get impacted, if there is delay in repayment?',
				content:
					'As per the RBI regulations, all loan repayments are required to be reported to the credit bureau. Any delay in repayments will be reflected in your credit score and may adversely impact your credit score. If you continue to pay your bills on time, it will improve your credit score and credit worthiness for future borrowings.',
			},
		],
	},
	'Credit Card Bill Payment': {
		img: CCBillPayment,
		faqs: {
			BILLDESK: [
				{
					title: `when will this payment reflect in my credit card account?`,
					content: (
						<>
							<p className="mr-t-5">this payment should reflect in your credit card account within 4 working days. </p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment pending?`,
					content: (
						<>
							<p className="mr-t-5">
								in rare cases, due to technical issues, your payment may go into a pending state. amount, if debited,
								will be refunded to your source account within 5 days.
							</p>
						</>
					),
				},
				{
					title: `my payment has failed and the amount is deducted from my account. when will this amount be refunded?`,
					content: (
						<>
							<p className="mr-t-5">
								in case of a payment failure, amount, if debited from your account, will be refunded to your source
								account within 5 working days.
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment not reflecting in my card account?`,
					content: (
						<>
							<p className="mr-t-5">
								your card issuing bank may take up to 4 working days to reflect the paid amount in your credit card
								account. please remember to pay your credit card bill at least 4 working days before the due date to
								avoid late fees charged by your issuer bank
							</p>
						</>
					),
				},
			],
			JUSPAY: [
				{
					title: `when will this payment reflect in my credit card account?`,
					content: (
						<>
							<p className="mr-t-5">this payment should reflect in your credit card account within 2 working days. </p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment pending?`,
					content: (
						<>
							<p className="mr-t-5">
								in rare cases, due to technical issues, your payment may go into a pending state. amount, if debited,
								will be refunded to your source account within 5 days.
							</p>
						</>
					),
				},
				{
					title: `my payment has failed and the amount is deducted from my account. when will this amount be refunded?`,
					content: (
						<>
							<p className="mr-t-5">
								Depending on the mode of payment and in case of a payment failure, amount, if debited from your account,
								will be refunded to your source account within 5 working days.
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment not reflecting in my card account?`,
					content: (
						<>
							<p className="mr-t-5">
								your card issuing bank may take up to 2 working days to reflect the paid amount in your credit card
								account. please remember to pay your credit card bill at least 3 working days before the due date to
								avoid late fees charged by your issuer bank
							</p>
						</>
					),
				},
			],
			POSTPE_JS: [
				{
					title: `when will this payment reflect in my credit card account?`,
					content: (
						<>
							<p className="mr-t-5">this payment should reflect on your credit card within 2 working days.</p>
							<p className="mr-t-5">
								in case your payment fails, the debited amount will be refunded to your limit within 3 working days.{' '}
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment pending?`,
					content: (
						<>
							<p className="mr-t-5">
								in rare cases, due to technical issues, your payment may go into a pending state. in case your payment
								fails, the debited amount will be refunded to your limit within 3 working days.
							</p>
						</>
					),
				},
				{
					title: `my payment has failed and the amount is deducted from my account. when will this amount be refunded?`,
					content: (
						<>
							<p className="mr-t-5">
								in case your payment fails, the debited amount will be refunded to your limit within 3 working days.{' '}
							</p>
						</>
					),
				},

				{
					title: `why is my credit card bill payment not reflecting in my card account?`,
					content: (
						<>
							<p className="mr-t-5">
								your card issuing bank may take up to 2 working days to reflect the paid amount in your credit card
								account. please remember to pay your credit card bill at least 3 working days before the due date to
								avoid late fees charged by your issuer bank.
							</p>
						</>
					),
				},
			],
			POSTPE_BD: [
				{
					title: `when will this payment reflect in my credit card account?`,
					content: (
						<>
							<p className="mr-t-5">
								this payment should reflect on your credit card within 4 working days.
								<br /> in case your payment fails, the debited amount will be refunded to your limit within 4 working
								days.
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment pending?`,
					content: (
						<>
							<p className="mr-t-5">
								in rare cases, due to technical issues, your payment may go into a pending state. <br />
								in case your payment fails, the debited amount will be refunded to your limit within 4 working days.{' '}
							</p>
						</>
					),
				},
				{
					title: `my payment has failed and the amount is deducted from my account. when will this amount be refunded?`,
					content: (
						<>
							<p className="mr-t-5">
								in case your payment fails, the debited amount will be refunded to your limit within 3 working days.
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment not reflecting in my card account?`,
					content: (
						<>
							<p className="mr-t-5">
								your card issuing bank may take up to 4 working days to reflect the paid amount in your credit card
								account. <br />
								please remember to pay your credit card bill at least 5 working days before the due date to avoid late
								fees charged by your issuer bank.
							</p>
						</>
					),
				},
			],
			postpeEnabled: [
				// {
				// 	title: `why should i use bharatpe to pay my credit card bill?`,
				// 	content: (
				// 		<>
				// 			<p className="mr-t-5">
				// 				• You can pay your credit card bill by using send money or other modes. You can earn upto 0.4% cashback
				// 				upto ₹1,000 on your first 5 credit card bill payments in a calendar month. you can use this cashback
				// 				against your monthly bill repayment of bharatpe. <br />
				// 			</p>
				// 		</>
				// 	),
				// },
				{
					title: `how do I pay my credit card bill on bharatpe?`,
					content: (
						<>
							<p className="mr-t-5">
								to pay your credit card bill on bharatpe <br /> <br />
								• tap on credit card bill payment on home screen <br />
								• select your credit card or add card <br />
								• enter your credit card details <br />
								• enter the amount
								<br />• choose payment mode (net banking or upi) for easy payment of your credit card bill.
							</p>
						</>
					),
				},
				// {
				// 	title: `How can I pay my credit card bill using send money feature of bharatpe app?`,
				// 	content: (
				// 		<>
				// 			<p className="mr-t-5">
				// 				You can pay your credit card bill using send money feature in two simple steps: <br /> 1. Transfer your
				// 				bill amount in your bank using Send Money through Credit card bill payments flow on the bharatpe App.{' '}
				// 				<br /> 2. Pay your credit card bill using UPI or Net Banking Complete both transactions to earn 0.4%
				// 				cashback (up to ₹1,000)
				// 			</p>
				// 		</>
				// 	),
				// },
				// {
				// 	title: `Why should I pay my credit card bill using send money payment mode?`,
				// 	content: (
				// 		<>
				// 			<p className="mr-t-5">
				// 				You can earn 0.4% cashback (up to ₹1,000) on paying your credit card bill via send money.
				// 			</p>
				// 		</>
				// 	),
				// },
				// {
				// 	title: `How can I earn 2x cashback on all my credit card bill payments?`,
				// 	content: (
				// 		<>
				// 			<p className="mr-t-5">
				// 				This 2x cashback will be calculated on the credit card bill payment amount up to which you have
				// 				successfully completed Send Money transactions through the Credit card bill payment flow*. <br /> A user
				// 				completes 5 Send Money transactions of ₹50,000 in a month. The user can earn 0.4% cashback on CCBP paid
				// 				via UPI or Net Banking on ₹50,000 only. I.e. maximum cashback a user can earn on this transaction is
				// 				₹200.
				// 				<br />
				// 				<br />
				// 				*Send money transactions outside the credit card bill payment flow shall not be considered for earning
				// 				cashback.
				// 			</p>
				// 		</>
				// 	),
				// },
				// {
				// 	title: `What is the validity of my 2x cashback offer?`,
				// 	content: (
				// 		<>
				// 			<p className="mr-t-5">
				// 				The 2x cashback will be valid till the end of the calendar month in which it is unlocked.
				// 			</p>
				// 		</>
				// 	),
				// },
				{
					title: `Are there any charges on paying my credit card bill using send money?`,
					content: (
						<>
							<p className="mr-t-5">No, charges will not apply on your credit card bill payments</p>
						</>
					),
				},
				{
					title: `when will this payment reflect in my credit card account?`,
					content: (
						<>
							<p className="mr-t-5">
								payment made by you should reflect in your credit card account within 2-4 working days.
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment pending?`,
					content: (
						<>
							<p className="mr-t-5">
								in rare cases, due to technical issues, your payment may go into a pending state. amount, if debited,
								will be refunded to your source account within 5 days.
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment not reflecting in my card account?`,
					content: (
						<>
							<p className="mr-t-5">
								your card issuing bank may take up to 4 working days to reflect your paid amount in your credit card
								account. please remember to pay your credit card bill at least 4 working days before the due date to
								avoid late fees charged by your issuer bank.
							</p>
						</>
					),
				},
			],
			ccbpSMDisabled: [
				{
					title: `why should i pay my credit card bill on bharatpe?`,
					content: (
						<>
							<p className="mr-t-5">
								• You can pay your credit card bill by using bharatpe limit or other modes. You can earn 0.25% cashback
								upto ₹1,000 on your first 5 credit card bill payments in a calendar month. <br />
								<br />* only for non-bharatpe limit transactions and is subject to change at the sole discretion of{' '}
								<span className="text-case-default">RDSPL</span>.
							</p>
						</>
					),
				},
				{
					title: `how do I pay my credit card bill on bharatpe?`,
					content: (
						<>
							<p className="mr-t-5">
								to pay your credit card bill on bharatpe <br /> <br />
								• tap on credit card bill payment on home screen <br />
								• select your credit card or add card <br />
								• enter your credit card details <br />
								• enter the amount
								<br />• choose payment mode (bharatpe limit, net banking or upi) for easy payment of your credit card
								bill.
							</p>
						</>
					),
				},
				{
					title: `are there any charges for paying a credit card bill on bharatpe?`,
					content: (
						<>
							<p className="mr-t-5">
								• yes, you will be charged a nominal fee for paying your credit card bills with the bharatpe limit
								Refer:{' '}
								<span className="underline" onClick={openCharges}>
									charges section
								</span>
								<br />• paying your credit card bill with netbanking or upi payment modes is free of charge
							</p>
						</>
					),
				},
				{
					title: `can i pay my credit card bill using the bharatpe credit limit?`,
					content: (
						<>
							<p className="mr-t-5">
								yes,eligible users can pay their credit card bill using their bharatpe limit. <br />
								you can also pay your credit card bill through netbanking or upi payment modes.
							</p>
						</>
					),
				},
				{
					title: `when will this payment reflect in my credit card account?`,
					content: (
						<>
							<p className="mr-t-5">
								payment made by you should reflect in your credit card account within 2-4 working days.
							</p>
						</>
					),
				},
				{
					title: `Do I earn cashback on credit card bill payments?`,
					content: (
						<>
							<p className="mr-t-5">
								yes, you earn 0.25% instant cashback (up to ₹1,000) on your first 5 credit card bill payments in a
								calendar month against your credit card bill when paying with a net banking or UPI. you can use this
								cashback against your monthly bill repayment of bharatpe. <br />
								<br />* cashback is not applicable on paying by bharatpe limit and is subject to change at the sole
								discretion of <span className="text-case-default">RDSPL</span>
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment pending?`,
					content: (
						<>
							<p className="mr-t-5">
								in rare cases, due to technical issues, your payment may go into a pending state. amount, if debited,
								will be refunded to your source account within 7 days (if paid with bharatpe limit, refund within 3
								working days).
							</p>
						</>
					),
				},

				{
					title: `why is my credit card bill payment not reflecting in my card account?`,
					content: (
						<>
							<p className="mr-t-5">
								your card issuing bank may take up to 4 working days to reflect your paid amount in your credit card
								account. please remember to pay your credit card bill at least 4 working days before the due date to
								avoid late fees charged by your issuer bank.
							</p>
						</>
					),
				},
			],
			postpeDisabled: [
				{
					title: `why should  I use bharatpe to pay my credit card bill`,
					content: (
						<>
							<p className="mr-t-5">
								- you can pay your credit card bill by using UPI or netbanking. you can earn upto 0.25% cashback upto
								₹1,000 on your first 5 credit card bill payments in a calendar month.
							</p>
						</>
					),
				},
				{
					title: `how do i pay my credit card bill on bharatpe?`,
					content: (
						<>
							<p className="mr-t-5">
								to pay your credit card bill on bharatpe: <br />
								• tap on credit card bill payment on home screen <br />
								• select your credit card or add card <br />
								• enter your credit card details <br />
								• enter the amount <br />• choose payment mode (net banking or upi) for easy payment of your credit card
								bill
							</p>
						</>
					),
				},
				{
					title: `when will this payment reflect in my credit card account?`,
					content: (
						<>
							<p className="mr-t-5">
								payment made by you should reflect in your credit card account within 2-4 working days.
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment pending?`,
					content: (
						<>
							<p className="mr-t-5">
								in rare cases, due to technical issues, your payment may go into a pending state. amount, if debited,
								will be refunded to your source account within 5 days.
							</p>
						</>
					),
				},
				{
					title: `why is my credit card bill payment not reflecting in my card account?`,
					content: (
						<>
							<p className="mr-t-5">
								your card issuing bank may take up to 4 working days to reflect your paid amount in your credit card
								account. please remember to pay your credit card bill at least 4 working days before the due date to
								avoid late fees charged by your issuer bank.
							</p>
						</>
					),
				},
			],
			secureCardPostpeEnabled: [
				{
					title: `Why should I Secure/Tokenise my Card?`,
					content: (
						<>
							<p className="mr-t-5">
								A secure/tokenized card transaction is safer as the actual card details are not shared / stored with the
								merchants to perform the transaction. Securing/Tokenisation also helps you save the hassle of entering
								your complete card details repeatedly.
							</p>
						</>
					),
				},
				{
					title: `How do I Secure/Tokenise my Card?`,
					content: (
						<>
							<p className="mr-t-5">
								• Click on secure card or directly after an add card transaction is completed. <br />
								• Tick mark the check box “Secure your Card” or “Save Card as per RBI guidelines”. <br />
								• Enter the OTP received on your registered mobile number. <br />• Your card details are now secured.
							</p>
						</>
					),
				},
				{
					title: `Are my card details safe after I Secure/Tokenise my Card?`,
					content: (
						<>
							<p className="mr-t-5">
								Actual card data, token and other relevant details are stored in a secure encrypted mode by authorised
								card networks and/or our TSP.
							</p>
						</>
					),
				},
				{
					title: `What are the charges that I need to pay for availing this tokenisation service?`,
					content: (
						<>
							<p className="mr-t-5">No charges will be levied for availing this service.</p>
						</>
					),
				},
			],
			secureCardPostpeDisabled: [
				{
					title: 'Why should I Secure/Tokenise my Card?',
					content: (
						<>
							<p className="mr-t-5">
								A secure/tokenized card transaction is safer as the actual card details are not shared/stored with the
								merchants to perform the transaction. Securing/Tokenisation also helps you save the hassle of entering
								your complete card details repeatedly.
							</p>
						</>
					),
				},
				{
					title: 'How do I Secure/Tokenise my Card?',
					content: (
						<>
							<p className="mr-t-5">
								• Click on secure card or directly after an add card transaction is completed. <br />
								• Tick mark the check box “Secure your Card” or “Save Card as per RBI guidelines”. <br />
								• Enter the OTP received on your registered mobile number. <br /> • Your card details are now secured.
							</p>
						</>
					),
				},
				{
					title: 'Are my card details safe after I Secure/Tokenise my Card?',
					content: (
						<>
							<p className="mr-t-5">
								Actual card data, token and other relevant details are stored in a secure encrypted mode by authorised
								card networks and/or our <span className="text-case-default">TSP</span>.
							</p>
						</>
					),
				},
				{
					title: 'What are the charges that I need to pay for availing this tokenisation service?',
					content: (
						<>
							<p className="mr-t-5">No charges will be levied for availing this service.</p>
						</>
					),
				},
			],
		},
	},
	'Bills and Recharges': {
		img: BharatBillImg,
		faqs: [

				// {
				//   title: `Why should I pay my utility bills on postpe?`,
				//   content: (
				//     <>
				//       <p className="mr-t-5">
				//         you may be eligible to earn a cashback up to ₹1,000 per month by
				//         paying your bills via upi which you can redeem against any
				//         utility bills, up to ₹100 per bill.
				//       </p>
				//     </>
				//   ),
				// },
				{
				  title: `How do I pay my utility bills on bharatpe?`,
				  content: (
					<>
					  <p className="mr-t-5">
						for bill payments and recharges on bharatpe:
					  </p>
					  <p className="mr-t-5">
						- tap on the &quot;bill payments&quot; banner on the bharatpe home
						screen
					  </p>
					  <p className="mr-t-5">
						- select the bill payment/ recharge category
					  </p>
					  <p className="mr-t-5">- enter your details</p>
					  <p className="mr-t-5">- enter amount/ choose your plan</p>
					  <p className="mr-t-5">
						- complete payment with authorisation for easy payment of your
						bills
					  </p>
					</>
				  ),
				},
				{
				  title: `Are there any charges for paying utility bills on bharate?`,
				  content: (
					<>
					  <p className="mr-t-5">
						no, you will not be charged any fee for paying your utility
						bills.
						{/* <span
						  style={{ textDecoration: 'underline' }}
						  onClick={openCharges}
						>
						  charges section
						</span> */}
					  </p>
					</>
				  ),
				},
				{
				  title: `What are the available payment modes for utility bill payments and recharges?`,
				  content: (
					<>
					  <p className="mr-t-5">
						you can use upi for bill payments and recharges.
					  </p>
					</>
				  ),
				},
				// {
				//   title: `Do I earn cashback for making utility bill payments on postpe?`,
				//   content: (
				//     <>
				//       <p className="mr-t-5">
				//         Yes, you can earn cashback on your first transaction for each of
				//         the following categories every month:
				//       </p>
				//       <p className="mr-t-5">
				//         - Mobile prepaid (minimum bill: ₹200)
				//       </p>
				//       <p className="mr-t-5">- DTH (minimum bill: ₹300)</p>
				//       <p className="mr-t-5">
				//         - Mobile postpaid (minimum bill: ₹500)
				//       </p>
				//       <p className="mr-t-5">- LPG (minimum bill: ₹800)</p>
				//       <p className="mr-t-5">
				//         - Electricity (minimum bill: ₹2,000)
				//       </p>
				//       <p className="mr-t-5">
				//         You can earn upto ₹130 per month when you pay for your utility
				//         bills and recharges on postpe. Your cashback earning will be
				//         capped at ₹1,000 in a month across the postpe app.
				//       </p>
				//     </>
				//   ),
				// },
				{
				  title: `When will the bill payment/ recharge reflect in my account?`,
				  content: (
					<>
					  <p className="mr-t-5">
						The payment should reflect in your account within 3 working
						days.
					  </p>
					</>
				  ),
				},
				{
				  title: `My bharatpe limit was debited, but the utility bill payment/ recharge failed. What should I do?`,
				  content: (
					<>
					  <p className="mr-t-5">
						In case the payment fails, the debited amount will be refunded
						to your bharatpe limit within 1 working day.
					  </p>
					</>
				  ),
				},
				{
				  title: `Why is my utility bill payment/ recharge pending?`,
				  content: (
					<>
					  <p className="mr-t-5">
						The payment may go into pending state due to technical issues.
						In case the transaction fails debited amount will be refunded to
						your bharatpe limit within 4 working days.
					  </p>
					</>
				  ),
				},
				{
				  title: `Why is the payment not reflecting in my account even after a successful
				  utility bill payment/ recharge?`,
				  content: (
					<>
					  <p className="mr-t-5">
						Your biller may take up to 3 working days to reflect the payment
						in your account. Please pay your bill at least 3 working days
						before your due date to avoid any late fees.
					  </p>
					</>
				  ),
				},
				{
				  title: `I accidently made a payment for a wrong account. Can I get a refund?`,
				  content: (
					<>
					  <p className="mr-t-5">
						No, once a bill payment is made, it cannot be cancelled or
						refunded. You may reach out to your biller for further
						assistance.
					  </p>
					</>
				  ),
				},
				{
				  title: `I mistakenly entered the wrong bill amount and paid my bill. What should I do?`,
				  content: (
					<>
					  <p className="mr-t-5">
						Once a bill payment is made, it cannot be cancelled or refunded.
						You may reach out to your biller for further assistance.
					  </p>
					</>
				  ),
				},
				{
				  title: `I cannot find my biller on bharatpe. How do I make a bill payment/ recharge?`,
				  content: (
					<>
					  <p className="mr-t-5">
						Currently, you can make a utility bill payment for only the
						listed billers as displayed on the bharatpe app. It is possible
						that your biller is presently not listed on bharatpe. Please reach
						out to bharatpe if your biller is not presently listed on the app.
					  </p>
					</>
				  ),
				},
				{
				  title: `I cannot find my account details under my biller on bharatpe. How do I make the
				  utility bill payment/ recharge?`,
				  content: (
					<>
					  <p className="mr-t-5">
						Please confirm whether the entered details are correct including
						the chosen biller and account number, among other required
						details. If you still cannot find your account under the chosen
						biller, you may reach out to your biller for further assistance.
					  </p>
					</>
				  ),
				},
				{
				  title: `Can I prepay my
				  utility bills using my bharatpe limit?`,
				  content: (
					<>
					  <p className="mr-t-5">
						Depending on your biller and bill type, you may prepay your
						bill.
					  </p>
					</>
				  ),
				},

		]
	},
	// waitlist screen
	Faqs: {
		faqs: [
			{
				title: `why did i not recieve bharatpe limit ?`,
				content: (
					<>
						<p className="mr-t-5">
							Assigning a bharatpe limit is dependent on various factors and you might not meet our eligibility
							criteria. However, you have different ways through which you can still unlock bharatpe! We are also
							constantly adding new ways, so stay connected with our app for future updates
						</p>
					</>
				),
			},
			{
				title: `can i unlock bharatpe by referring my friends ?`,
				content: (
					<>
						<p className="mr-t-5">
							yes, you can. If 3 of your friends get a bharatpe limit, you will instantly unlock bharatpe.{' '}
						</p>
					</>
				),
			},

			{
				title: `I referred 3 friends but did not get a limit?`,
				content: (
					<>
						<p className="mr-t-5">
							a successful referral is when a friend you refer is allocated a bharatpe limit. You can unlock bharatpe
							only when 3 of your friends have successfully gotten a bharatpe limit
						</p>
					</>
				),
			},
		],
	},
	'Send Money': {
		img: SendMoneyImg,
		faqs: [
			{
				title: `What is send money and how can I send money to my own bank accounts from bharatpe?`,
				content: (
					<>
						<p>Send Money makes taking your limit to your bank account swift and easy.</p>
						<p className="mr-t-5">
							Simply choose one of your linked bank accounts and select the amount (from your approved limit) that you
							would like to send to it.
						</p>
						<p className="mr-t-5">This amount would then be deducted from your limit.</p>
						<p>The money you send will be credited to your bank account.</p>
						<p>So enjoy having the bharatpe magic sent right to your bank account !</p>
					</>
				),
			},
			{
				title: `What are the charges for send money?`,
				content: (
					<>
						<p>
							We charge a nominal convenience fee for transferring funds to your registered bank account (inclusive of
							all taxes) along with a payment processing fee of up to <span className="text-case-default">Rs.25</span>{' '}
							on every transaction. Refer:{' '}
							<span className="underline" onClick={openCharges}>
								charges section
							</span>
						</p>
					</>
				),
			},
		],
	},
	'Bharatpe Loan': {
		img: CashMax,
		faqs: [
			{
				title: `What is Bharatpe Loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							bharatpe Loan is a personal loan offering where you can avail a loan of up to INR 15 Lakhs through bharatpe
							app from RBI regulated entities, for any of your personal financial needs.
						</p>
						<p className="mr-t-10 text-case-default">Key Features of Bharatpe Loan: </p>
						<p className="mr-t-10 text-case-default">- Low Rates of Interest</p>
						<p className="mr-t-10 text-case-default">- No collateral or security required</p>
						<p className="mr-t-10 text-case-default">- Tenure: 3 - 15 months</p>
						<p className="mr-t-10 text-case-default">- Repayment in Easy Monthly Installments (EMI)</p>
						<p className="mr-t-10 text-case-default">- Quick and hassle free process</p>
					</>
				),
			},
			{
				title: `How can I pay my EMI?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							- Your monthly installment will be automatically debited on 5th of the month through E-NACH, which gets
							registered before the loan gets disbursed to your bank account.
						</p>
						<p className="mr-t-10 text-case-default">
							- However, you can pay your EMI in advance through UPI, Netbanking & through a debit card on the bharatpe
							app.
						</p>
					</>
				),
			},
			{
				title: `How long does it take to disburse the Bharatpe Loan amount?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							As long as you are eligible for a bharatpe Loan, you may be able to get your amount transferred directly
							into your bank account within 24 - 48 hours of applying for the loan on the bharatpe app.
						</p>
					</>
				),
			},
			{
				title: `What is the difference between my bharatpe limit and bharatpe Loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							- Your bharatpe limit is the maximum approved credit limit offered to you through bharatpe app from RBI
							regulated entities.
						</p>
						<p className="mr-t-10 text-case-default">
							- Whereas, bharatpe loan is a sub-set of said credit limit. From this available credit limit, you can
							avail a bharatpe loan at a particular rate of interest and tenure.
							<br />
							For instance, if your bharatpe limit is for INR 25,000/- and you decide take INR 20,000/- into your bank
							account for a period of 3 months at 14% interest then in this case the total limit is INR 25000/- is and
							INR 20,000/- is the bharatpe loan. Therefore, now the remaining amount in your bharatpe limit is INR
							5,000/- Which can be either drawn as per your profile and risk assessment or can be used on other products
							and services on the bharatpe app such as QR payments, utility bill payments etc.
						</p>
					</>
				),
			},

			{
				title: `What is the difference between Bharatpe Loan and Send Money?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Both Send Money and bharatpe Loan are the features of the bharatpe app:
						</p>
						<p className="mr-t-10 text-case-default">
							- Send Money allows you to drawdown from the bharatpe limit to your linked bank account. It’s interest
							free till the subsequent bill generation date of the bharatpe limit.
						</p>
						<p className="mr-t-10 text-case-default">
							- bharatpe Loan is a personal loan offering which can be availed at a particular rate of interest and for
							a tenure of minimum 3 months ranging up to a maximum of 15 months
						</p>
					</>
				),
			},
			{
				title: `What happens if I repay my bharatpe Loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							The repaid amount will be added back to your bharatpe credit limit.
						</p>
					</>
				),
			},
			{
				title: `Who is giving me the loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							bharatpe is the digital lending platform which facilitates you to avail the credit limit from RBI regulated
							entities. The bharatpe loan is a sub-set of the bharatpe limit, the same RBI regulated entity will be
							extending this loan.
						</p>
					</>
				),
			},
			{
				title: `What is the maximum and minimum amount that can be disbursed as Bharatpe Loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							The minimum amount that you can avail as bharatpe Loan is INR10,000 while the maximum amount is INR15
							Lakhs. This will be based on the underwriting done by the RBI regulated entity offering the bharatpe
							limit.
						</p>
					</>
				),
			},
			{
				title: `What is the interest that I need to pay on my Bharatpe Loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Interest rates vary based on your profile, the credit score, history of repayments and the internal credit
							and risk policies of the RBI regulated entity offering the bharatpe Loan. For bharatpe Loan, the interest
							rates start at 14% (reducing) per annum. The exact rate of interest will be shown on the bharatpe app at
							the time of opting for the bharatpe loan.
						</p>
					</>
				),
			},
			{
				title: `What is the loan tenure of Bharatpe Loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							The loan tenure ranges from a minimum of 3 months up to a maximum of 15 months.
						</p>
					</>
				),
			},
			{
				title: `What is an EMI?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							EMI is the equated monthly installment you pay towards your bharatpe Loan at a specified interest rate
							over a specified loan tenure.
						</p>
					</>
				),
			},

			{
				title: `What is Broken Period Interest / Advance EMI?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							-Broken Period Interest (BPI) refers to the interest charged between the disbursal date till the upcoming
							bill due date. For example, if the disbursal date is 29th January for a loan amount of INR 1,60,000/- @36%
							interest rate p.a, then a BPI of INR 1,105/- will be charged for 7 days from 29th Jan to 5th Feb
							(1,60,000*36%*7/365).
						</p>
						<p className="mr-t-10 text-case-default">
							- The BPI is only charged in case the date of loan disbursal is between 6th - 30th/31st (as applicable)of
							the month.
						</p>
						<p className="mr-t-10 text-case-default">- EMI will become due w.e.f. 5th March</p>
					</>
				),
			},
			{
				title: `What happens if I don’t repay on time?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							- Your CIBIL score will be impacted, which will affect your ability to avail loans from any bank or
							financial institution in the future. Your profile will also be updated as a defaulter with various credit
							rating agencies. For every day that you default on your payment, you will have to pay a penalty over and
							above the principal and interest amount.
						</p>
						<p className="mr-t-10 text-case-default">
							- You will automatically be ineligible for availing a quicker bharatpe Loan of a prospectively higher
							value through bharatpe in the future.
						</p>
						<p className="mr-t-10 text-case-default">
							- Penal charges will get levied on the overdue amount as per the loan documents
						</p>
					</>
				),
			},
			{
				title: `Can I change the loan tenure once the Bharatpe Loan amount has been disbursed?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							No, once the bharatpe Loan amount is approved and disbursed, you cannot change the loan terms such as
							amount and repayment date.
						</p>
					</>
				),
			},
			{
				title: `Do I need to provide any collateral/ security for availing a Bharatpe Loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Relax. We trust you. We require no collateral. Simply provide us your valid documents so we can determine
							your eligibility and you’re all set!
						</p>
					</>
				),
			},
			{
				title: `Can I repay or foreclose my loan before the due date?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Absolutely, you can! In fact, making payments in advance helps improve your eligibility.
						</p>
					</>
				),
			},
			{
				title: `My auto debit has failed multiple times. What should I do?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Auto debit fails in case you don’t have sufficient amount payable on EMI in your linked bank account. In
							case the auto debit fails, the user can manually pay the EMI amount on the bharatpe app before the due
							date without any penalty getting charged.
						</p>
					</>
				),
			},
			{
				title: `How can I reach the bharatpe help desk for any query?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							To ensure that your concerns are addressed and resolved in a timely manner, please follow the process set
							out under Grievance Redressal Policy: <Url url="https://postpe.app/grievance-redressal.html" />
						</p>
					</>
				),
			},
			{
				title: `How are send money and bharatpe loan limits related?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Your send money limit is a subset of your bharatpe loan limit. transferring money to bank account using
							one mode impacts the available limit of the other. In order to maximise limit available, kindly select the
							maximum tenure while taking bharatpe loan.
						</p>
					</>
				),
			},
			{
				title: (
					<span>
						My send money limit has reduced after taking <span className="text-case-default">PL</span>
					</span>
				),
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							You can unlock your send money limit by: <br />
							1. Repaying bills to unlock send money used limit <br />
							2. Closing/Foreclosing of active bharatpe loan
						</p>
					</>
				),
			},
		],
	},
	splitpay: {
		img: BlueQr,
		faqs: [
			{
				title: 'What is Splitpay?',
				content: (
					<>
						Splitpay is a product on the bharatpe app that allows you to convert your transactions into convenient and
						flexible loans with selected repayment options.
					</>
				),
			},
			{
				title: 'How does Splitpay work?',
				content: (
					<>
						Instead of paying the entire amount upfront, you can split the cost over the specified tenure by way of
						converting it to an EMI.
					</>
				),
			},
			{
				title: 'What are the benefits of Splitpay?',
				content: (
					<>
						Splitpay offer several benefits, including:
						<br />
						<span className="font-heavy">Affordability: </span>By converting your purchase into EMIs, you can manage
						your budget better and make big-ticket purchases without straining your finances.
						<br /> <span className="font-heavy"> Flexibility: </span> Choose from various tenure options and tailor your
						repayment plan to suit your financial situation.
						<br />
						<span className="font-heavy"> No PF or EMI Conversion fee: </span>0% processing fee and no EMI conversion
						cost on any EMI conversion.
					</>
				),
			},
			{
				title: 'What is the minimum amount that can be converted to Splitpay?',
				content: <>The minimum amount that can be converted to Splitpay is Rs 2000 per transaction.</>,
			},
			{
				title: 'Can I choose the repayment tenure? ',
				content: (
					<>
						Yes, this EMI conversion product offers flexibility in choosing the repayment tenure. You can select a
						tenure that suits your repayment capacity, ranging from 3 to 15 months.
					</>
				),
			},
			{
				title: 'Are there any additional charges associated with Splitpay?',
				content: <>There is a 0% processing fee and no EMI conversion cost on any EMI conversion.</>,
			},
			{
				title: 'Does the user need to pay any down payment at the time of the transaction?',
				content: <>No down payment needs to be paid at the time of the transaction.</>,
			},
			{
				title: 'What happens if I miss an EMI payment?',
				content: (
					<>
						Missing an EMI payment can result in late payment fees or penalties. It's crucial to make timely payments to
						avoid any negative impact on your credit score or additional financial burden.
					</>
				),
			},
			{
				title: 'Do other limits get impacted if we use Splitpay?',
				content: (
					<>
						Splitpay is a subset of the bharatpe limit. Using Splitpay may impact your other available limits (personal
						loan limit, Send money limit).
					</>
				),
			},
			{
				title: 'How to foreclose Splitpay?',
				content: <>Foreclosure can be easily done without paying any foreclosure charges.</>,
			},
		],
	},
	'bharatpe bills': {
		img: BillsImg,
		faqs: [
			{
				title: `How is my bill generated?`,
				content: (
					<>
						<p>
							The billing cycle begins on the 1st day of the month and ends on the last of the same month. Limit
							utilised during the month on either scanning a QR , sending money directly to your bank account, making
							utility bill payments, or availing a personal loan is consolidated and settled on the 1st day of the next
							month.
						</p>
						<p className="mr-t-10">
							{' '}
							For example, the billing cycle for the month of April '23 would work as follows: Transactions between
							April 1 '23 and April 30 '23 will be billed together. The bill for the April '23 cycle is generated on May
							1 '23.
						</p>
					</>
				),
			},
			{
				title: `How can I pay my bill?`,
				content: (
					<>
						<p>On the home screen, click "Pay Now" or "Clear Dues" to clear your bill.</p>
						<p className="mr-t-5">• To pay now, you can pay via several options like UPI, debit card, or netbanking</p>
						<p className="mr-t-5">
							• You can choose an EMI with tenure of your choice. First EMI will need to be repaid at the time of EMI
							conversion.
						</p>
					</>
				),
			},
			{
				title: `What is the due date for my bill?`,
				content: `Your bill will be generated on the 1st of next month. You will be given 5 days grace period from the bill date to repay the amount.`,
			},
			{
				title: `What are the charges?`,
				content: (
					<>
						<p>• If you settle your bill in full on or before 5th the bill of the month, no charges are levied.</p>
						<p className="mr-t-10">
							• If you convert part of your bill amount into EMIs, flat rate is charged as mentioned in{' '}
							<span className="underline" onClick={openCharges}>
								charges section
							</span>
						</p>
						<p className="mr-t-10">
							• If you do not pay the bill till 5th of the month, you will have to pay the overdue charges as mentioned
							in your{' '}
							<span className="underline" onClick={openCharges}>
								charges section
							</span>{' '}
							from the bill generation date (1st of the month) to the date of making the payment{' '}
						</p>{' '}
					</>
				),
			},
			{
				title: 'Are there any interest charges on my EMIs?',
				content: 'Yes, you will be charged a flat rate of interest per month as mentioned in your charges section.',
			},
			{
				title: `Where can I see my pending/ongoing EMIs?`,
				content: `You can see your pending and ongoing EMIs easily from the EMI statement page on your profile section.`,
			},
			{
				title: `What should I do if refunds come after the bill is generated?`,
				content: (
					<>
						<p>
							Usually, merchants send refund confirmation within 7 days, but it varies for different merchants. We will
							refund the cancelled transaction within three working days after receiving the confirmation. It might be
							possible that cancellation confirmation is received after the bill is generated for that period. In this
							case, your due amount will reduce accordingly.
						</p>
						<p className="mr-t-10">
							If the cancelled order refund came after the amount has been billed and paid, the same refunds will be
							added to your credit limit directly and the same carry forwarded amount will be adjusted in the upcoming
							bill. You can view your credit limit in the app.
						</p>
					</>
				),
			},
			{
				title: `My bharatpe account is blocked. How will it get reopened? `,
				content: `Your account may be blocked for various reason. In certain cases, the block on your account will be lifted immidiately when you pay the outstanding bill. If your account is blocked pursuant to suspected fraudulent transactions/risk parameters, we may not be able to lift the block on your account. `,
			},
			{
				title: `I converted my bill to EMIs. Why is my credit limit not getting unlocked by same amount as EMI paid`,
				content: (
					<>
						<p>
							Because EMI includes the interest component charged by our lending partner. you can check your interest
							rates in the{' '}
							<span className="underline" onClick={openCharges}>
								charges section
							</span>
						</p>
					</>
				),
			},
			{
				title: `Can I change my EMI plan?`,
				content: `Once the EMI has been opted by you, it cannot be changed.`,
			},
			{
				title: 'are there any charges for paying utility bills on bharatpe?',
				content: (
					<>
						yes, you will be charged a nominal fee for paying your utility bills only for the following categories with
						your bharatpe limit: clubs and associations, credit card, donation, loan, recurring deposit, rental payment
						and subscription. no fees will be levied on the remaining categories. Refer:{' '}
						<span className="underline" onClick={openCharges}>
							charges section
						</span>
					</>
				),
			},
		],
	},
	'Transaction Issues': {
		img: TransactionIssuesImg,
		faqs: [
			{
				title: 'My bharatpe transaction appears as pending. Where is my money?',
				content:
					'Transactions done using bharatpe card or send money to your bank can sometimes go pending. Usually, we resolve these transactions within 7 days post which they will either become successful or failed. We credit the amount back to your bharatpe credit limit in case of a failed transaction.',
			},
			{
				title: 'I repaid my bill. Money is deducted from my account but it does not reflect on the bharatpe app',
				content:
					'Usually, all repayments get cleared instantly on the bharatpe app. However, less than 1% transactions can have issues. Don’t worry! We work with your bank and resolve these issues within 7 days post which they will either become successful or failed. We refund the money back to your source account in case of a failed transaction. ',
			},
		],
	},
	Rewards: {
		img: RewardsImg,
		faqs: [
			{
				title: `how can i use my available cashback?`,
				content: `you will soon have the option to use your available cashback balance towards paying your utility bills. We will notify you when this feature becomes available.`,
			},
			{
				title: `Why am I unable to use my cashback?`,
				content: `Your cashback may have expired or your account has been blocked by bharatpe`,
			},
			{
				title: `what is cashback validity?`,
				content: `Cashback has a validity period of 180 days. Therefore, you have a period of 180 days to utilise the cashback earned by you.`,
			},
			{
				title: `why did my cashback expire?`,
				content: `In the event that you have not redeemed the earned cashback for more than 180 days, such unused/unredeemed cashback will expire.`,
			},
			{
				title: `will the whole amount of cashback expire?`,
				content: `no, only such cashback amount which was earned prior to the 180 day validity period shall expire.`,
			},
		],
	},
	'Lending partners': {
		img: LendingPartnerImg,
		faqs: [
			{
				title: 'Who are the lending partners for bharatpe?',
				content: (
					<>
						bharatpe is created in partnership with RBI regulated NBFCs. Currently, we work with three RBI regulated
						NBFCs: <br />
						1. Hindon Mercantile Limited <br />
						2. Innofin Solutions Private Limited (LenDenClub)
						<br />
						3. Trillionloans Fintech Pvt Ltd <br />
						4. NDX P2P private limited (Liquiloans) <br />
						You can check your lender by viewing your sanction letter in the ‘terms and condition’ section of your
						profile
					</>
				),
			},
			{
				title: 'How can I get in touch with my lender? ',
				content: (
					<>
						You can contact{' '}
						{lender === 'LDC'
							? 'LenDenClub'
							: lender === 'HINDON'
							? 'Hindon'
							: lender === 'Trillion'
							? 'Trillion'
							: 'Liquiloans'}
						&nbsp;at &nbsp;
						{lender === 'LDC' ? (
							<Url url="cs@lendenclub.com" />
						) : lender === 'HINDON' ? (
							<Url url="helpdesk.postpe@mufinfinance.com" />
						) : (
							<Url url="grievances@liquiloans.com" />
						)}
					</>
				),
			},
		],
	},
	Others: {
		img: FaqImg,
		faqs: [
			{
				title: `I want to talk to someone and need more help`,
				content: (
					<>
						Please email us on <Url url="mailto:help@postpe.app" alternateText="help@postpe.app" /> &nbsp;with your
						concern, and we will connect with you at the earliest.
					</>
				),
			},
		],
	},
	'AU Credit Card': {
		img: AuCCImg,
		faqs: [
			{
				title: 'What is a Credit Card?',
				content: (
					<>
						Credit Card is a payment instrument offering where you can avail a revolving credit limit of upto 6 lakhs
						from AU Small Finance Bank subject to the bank’s terms and conditions prescribed.Key Features: <br />
						<br />
						• Welcome & Milestone Benefits <br />
						• Complimentary Airport & Railway lounge access <br />
						• Accelerated Reward Points <br />
						• Customizable credit card features* <br />
						<br />
						*on select card variant only.
					</>
				),
			},
			{
				title: 'Who is giving the Credit Card?',
				content: 'The Credit Card is being directly offered to you by AU Small Finance Bank.',
			},
			{
				title: 'Why apply for AU Credit Card from bharatpe?',
				content: (
					<>
						When you apply for an AU Small Finance Bank credit card product through bharatpe, the first year annual fee*
						(upto Rs.499) will be credited in the form of cashback to your bharatpe account. Please note that this is
						contingent on successful issuance of the credit card. <br />
						<br />
						*note that this is only applicable on Altura & Altura+ card variants only
					</>
				),
			},
			{
				title: 'How will I use the Cashback?',
				content: 'You can use your cashback on the repayment of bharatpe bill for the month.',
			},
			{
				title: 'Why am I unable to use my Cashback?',
				content: 'Your cashback must have expired or your account has been blocked by bharatpe.',
			},
			{
				title: 'When will I receive my Cashback?',
				content: (
					<>
						The cashback will be processed within 15 working days from the card issuance date.
						<br />
						<br />
						<span className="font-heavy underline">Cashback will be credited to active bharatpe accounts only.</span>
					</>
				),
			},
			{
				title: 'When will I get my Credit card?',
				content: (
					<>
						Upon Successful completion of application process, you will get your card directly from AU Small Finance
						Bank within 7-10 working days. <br />
						<br />
						In case of any issues/concerns/assistance please reach out to AU Small Finance Bank directly at 1800 1200
						1500
					</>
				),
			},
			{
				title: 'Are there any additional charges for availing the Credit Card from AU Small Finance Bank?',
				content: (
					<>
						You can get the information about any additional charges by visiting{' '}
						<Url url="https://www.aubank.in/personal-banking/credit-cards" /> <br />
						Or by reaching out to AU Small Finance Bank at 1800 1200 1500
					</>
				),
			},
			{
				title: 'How can I reach AU Small Finance  Bank for any query/grievances/concerns?',
				content: (
					<>
						Please reach out to AU Small Finance Bank at 1800 1200 1500 or visit{' '}
						<Url url="https://www.aubank.in/support/contact-us" />
					</>
				),
			},
		],
	},
	VAS: {
		img: VasImg,
		faqs: [
			{
				title: 'what is the OneAssist DigiSecure program?',
				content: (
					<>
						DigiSecure program is an optional protection program offered by OneAssist against any kind of offline or
						online frauds on the debit/ credit cards, M-wallets and/ or UPI. in case of a fraudulent transaction on any
						of the protected assets, you can claim up to the insured amount as per the purchased plan.
					</>
				),
			},
			{
				title: 'what are the benefits of this plan?',
				content: (
					<>
						OneAssist DigiSecure has the following benefits: <br />
						<br />
						<p>
							• verified service on your fingertips - 24x7 assistance to report any fraud, on demand call, app and
							chatbot support.
						</p>
						<p>
							• complementary protection on card transactions - protection against offline and online card frauds
							including online, phishing ATM & physical swipes.
						</p>
						<p>
							• health package – diagnostic tests with free home sample collection, free tele-consultation with general
							physician and e-prescription assistance.
						</p>
						<p>• emergency travel assistance – emergency ticketing and hotel booking requests.</p>
						<p>• 1 – call to block to all bank cards SIM cards – quick fix for wallet loss.</p>
						<p>• DL and PAN replacement – free of cost PAN card and DL replacement. </p>
						<p>
							• complimentary UPI and M-wallet cover – to protect your M-wallet/ UPI transactions and worry-free.
							(select plans*)
						</p>
						<br />
						*please refer to plan specific terms and conditions
					</>
				),
			},
			{
				title: 'what is the duration of the OneAssist DigiSecure program?',
				content: <>your DigiSecure plan will be valid for 12 months from the date of plan activation.</>,
			},
			{
				title: 'how do i activate my plan?',
				content: 'the plan activates as soon as you buy the DigiSecure plan from OneAssist through the bharatpe app.',
			},
			{
				title: 'can i cancel my DigiSecure plan?',
				content:
					'yes, you can cancel your DigiSecure plan within 15 days of purchase to get a full refund. you will not be eligible to receive a refund, in case the membership is cancelled after 15 days or if you have raised a service request on your plan.',
			},
			{
				title: 'how can i cancel my plan? ',
				content: (
					<>
						you can reach out to <Url url="mailto:help@postpe.app" alternateText={'help@postpe.app'} /> to cancel your
						DigiSecure plan within the 15 days of purchasing the DigiSecure plan
					</>
				),
			},
			{
				title: 'where can i see the terms and conditions of the OneAssist DigiSecure program? ',
				content: (
					<>
						you will receive a welcome SMS with your membership details and detailed terms & conditions from OneAssist
						after you have activated your plan.
					</>
				),
			},
			{
				title: 'is this plan transferable?',
				content: <>no, the OneAssist DigiSecure plan is non-transferable.</>,
			},
			{
				title: 'how can i raise a claim under the OneAssist DigiSecure program?',
				content: (
					<>
						you can register your claim within 24 hours of discovering the loss by either <br /> 1. calling the
						OneAssist 24*7 toll-free helpline (1800 123 3330) <br />
						2. login to <Url url="https://oneassist.in/" alternateText={'www.oneassist.in'} /> <br />
						3. through the oneassist app available on Google Play Store & App Store <br />
						<br />
						the OneAssist team will register your service request and request documents for the same. <br />
						please refer to the plan specific terms and conditions for full claim registration procedure.
					</>
				),
			},
			{
				title: 'what documents do i need to provide at the time of claim?',
				content: (
					<>
						following claim forms are needed for claim servicing card fraud protection and M-wallet & UPI claims -
						<p>• claim form duly filled & signed by the customer.</p>
						<p>• FIR or intimation copy issued by the police in case of fraud value is over INR 5,000/-</p>
						<p>• confirmation for blocking the M-wallet/UPI account</p>
						<p>• bank statement indicating the fraudulent transaction</p>
						<p>• correspondence with the bank on the fraud including a dispute letter submitted to the bank</p>
						<p>• any other document(s) as may be required by OneAssist/insurer pertaining to the claim loss</p>
					</>
				),
			},
			{
				title: 'my credit card bill payment failed but my plan has been activated. what will happen?',
				content: (
					<>
						if such a scenario arises, we will cancel the entire transaction and refund the entire amount, i.e. credit
						card bill amount and purchased plan amount to the original payment method within 5 working days.{' '}
					</>
				),
			},
			{
				title: 'who should i reach out to in case of a query/ issue with regards to my DigiSecure Plan?',
				content: (
					<>
						please reach out directly to the OneAssist team by calling the OneAssist 24*7 toll-free helpline (1800 123
						3330)
					</>
				),
			},
			{
				title: 'Is it mandatory for me to opt in for the One Assist program?',
				content: <>no, the OneAssist DigiSecure plan is optional</>,
			},
		],
	},
	'Gift Vouchers': {
		img: voucherFaqs,
		faqs: [
			{
				title: 'what are gift vouchers?',
				content: (
					<>
						gift voucher is a prepaid, digital payment instrument that you can purchase through the bharatpe
						application, which will redirect you to our partner website. these vouchers can be used for bookings,
						shopping and payments. these vouchers can be used at offline stores and/ or on online platforms.
					</>
				),
			},
			{
				title: 'how can i purchase a voucher?',
				content: (
					<>
						you can purchase a gift voucher via upi. please follow the below mentioned steps to buy gift vouchers of
						your favorite brands:
						<br /> - enter the gift voucher platform i.e. vouchagram india private limited's platfom from the bharatpe
						app
						<br />
						- explore your favorite brands and select one of them - select the denomination and quantity <br />
						- complete the payment to purchase the voucher(s) <br />
						- the purchased gift voucher(s) will be delivered to your <br />
						mobile number and/ or email please note: for any issues concerning the purchase/ aforesaid steps, please
						reach out to the vouchagram team at 18001033313 or share your query at{' '}
						<Url url="https://www.gvhelpdesk.com/" /> .
					</>
				),
			},
			{
				title: 'where can i use how to redeem these vouchers?',
				content: (
					<>
						you can redeem gift vouchers online and/ or offline at the brand's website, application and brand store,
						according to the type of voucher. for voucher specific redemption details, please refer to the "how to use"
						section below the voucher list. please note: please read the "important instructions" mentioned on the brand
						page prior to making a purchase.
					</>
				),
			},
			{
				title: 'why should I buy gift vouchers on bharatpe?',
				content: (
					<>
						you can buy vouchers for 200+ brands with instant discounts on selected vouchers. you can search vouchers by
						brand, category, discount and online/ offline redemption.
					</>
				),
			},
			{
				title: 'how will I receive the vouchers?',
				content: (
					<>
						once the purchase is completed, the voucher(s) will be shared on your mobile number and/ or the email
						address provided by you. please note: bharatpe will not be responsible for sending these vouchers and for
						any issues/ queries please reach out to the vouchagram team at 18001033313 or share your query at
						<Url url="https://www.gvhelpdesk.com/" />.
					</>
				),
			},
			{
				title: 'i’ve lost my voucher sms email. can I get my voucher sms email again?',
				content: (
					<>
						yes, you can get the vouchers resent to the registered mobile number/ email id. please reach out to the
						vouchagram team at 18001033313 or share your query at <Url url="https://www.gvhelpdesk.com/" />.
					</>
				),
			},
			{
				title: 'who should i reach out to in case of a query issue?',
				content: (
					<>
						please reach out directly to the vouchagram team at 18001033313 or share your query at <br />
						<Url url="https://www.gvhelpdesk.com/" />
					</>
				),
			},
			{
				title: 'can my voucher terms be modified changed cancelled?',
				content: (
					<>
						yes, it is possible and the specific brand shall be responsible. please read the "important instructions"
						mentioned on the brand page prior to making a purchase.
					</>
				),
			},
		],
	},
	ECOM: {
		img: CashMax,
		faqs: [
			{
				title: `What is checkout with bharatpe?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Checkout with bharatpe now allows you to use your available bharatpe credit limit to pay for your
							purchases on selected online merchant websites/ apps.
						</p>
						<p className="mr-t-10 text-case-default">
							Use your bharatpe limit for apparel, grocery and more by selecting bharatpe as a payment option on the
							checkout page of the respective merchant.
						</p>
					</>
				),
			},
			{
				title: `How can I use bharatpe for payment on other websites/ apps?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							You can now use your available bharatpe limit on selected merchants in 3 simple steps
						</p>
						<p className="mr-t-10 text-case-default">1. Select bharatpe on the merchant's checkout page</p>
						<p className="mr-t-10 text-case-default">
							2. Login to your bharatpe account on the checkout page using OTP to confirm you have sufficient bharatpe
							credit limit
						</p>
						<p className="mr-t-10 text-case-default">
							3. Authenticate your transaction with an OTP to pay through bharatpe by using the available bharatpe limit
						</p>
					</>
				),
			},
			{
				title: `My order got cancelled by the merchant, how will I receive my refund?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							In case your order is cancelled by the merchant, your transaction amount will be refunded to you through
							your bharatpe limit. This may take up to 5 working days from date of refund initiation by the merchant.
						</p>
					</>
				),
			},
			{
				title: `My order has not been delivered to me, can I cancel this order?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							If your order has not been delivered, please contact the merchant directly for further information.
						</p>
					</>
				),
			},

			{
				title: `I have an issue related to the order/transaction I made using bharatpe. Can bharatpe help?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Please reach out to the relevant merchant for queries on order delivery/order cancellation/transaction.
						</p>
					</>
				),
			},
			{
				title: `Why am I not seeing bharatpe on the payment page of my favourite merchants?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							checkout with bharatpe is live only on selected merchants. We will keep enabling merchants to ensure a
							best in class experience for our customers.
						</p>
						<p className="mr-t-10 text-case-default">
							You will not be able to see bharatpe on the payment page in case we are not live with a merchant or if we
							are unavailable on the selected platform (iOS, android). Additionally, checkout with bharatpe could be
							unavailable due to changes in your bharatpe account.
						</p>
					</>
				),
			},
			{
				title: `I have two mobile numbers. I am registered on bharatpe with my primary number. Can I use bharatpe if I am signed in to a merchant app/ website from my secondary number?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							No, you will not be able to use checkout with bharatpe for the transaction if you have signed in from your
							secondary number.
						</p>
					</>
				),
			},
			{
				title: `What is the maximum and minimum amount that can be disbursed as Bharatpe Loan?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							The minimum amount that you can avail as bharatpe Loan is INR10,000 while the maximum amount is INR15
							Lakhs. This will be based on the underwriting done by the RBI regulated entity offering the bharatpe
							limit.
						</p>
					</>
				),
			},
			{
				title: `How is my refund adjusted against an order I have returned?
				`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Once your amount is refunded by the merchant, the amount is adjusted with your outstanding bharatpe dues.
						</p>
						<p className="mr-t-10 text-case-default">
							In case you receive a refund after your bill is paid, the refund amount will be added to your bharatpe
							limit. <br />
							In case your payable amount is lesser than the refund amount, the differential sum will be added to your
							bharatpe limit
						</p>
					</>
				),
			},
			{
				title: `Are there any charges for using checkout with bharatpe?
				`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							As a special introductory offer, zero charges will be levied for using checkout with bharatpe.
						</p>
					</>
				),
			},
			{
				title: `My bharatpe limit was debited twice for an order I placed? What should I do?
				`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							Any excess payment will be refunded to your bharatpe limit. <br />
							This may take up to 5 working days from date of refund initiation by the merchant.
						</p>
						<p className="mr-t-10 text-case-default">
							You can reach out to bharatpe on our customer support on +91 8449767873 or{' '}
							<Url url="mailto:help@postpe.app" alternateText="help@postpe.app" />
							&nbsp; to report your issue.
						</p>
					</>
				),
			},
			{
				title: `I have an issue with my order, till when can I raise my query to bharatpe?`,
				content: (
					<>
						<p className="mr-t-10 text-case-default">
							You can raise your query regarding a checkout with bharatpe order for up to 30 days from the date of
							order.
						</p>
					</>
				),
			},
		],
	},
	ONDC: {
		img: ONDC,
		faqs: [
			{
				title: 'How can I order food on ONDC via bharatpe?',
				content: (
					<>
						You can order food on ONDC through the bharatpe app via UPI payment mode
						<br />
						Please follow the below mentioned steps:
						<p>• Enter the ONDC section from the bharatpe app</p>
						<p>• Explore your favorite restaurants and food items</p>
						<p>• Add your choice of food to the cart</p>
						<p>• Enter/ select your address</p>
						<p>• Complete the payment to place the order</p>
					</>
				),
			},
			{
				title: 'My order has not been delivered to me. Can I cancel this order?',
				content: (
					<>
						Orders once placed cannot be cancelled. <br />
						If your order has not been delivered, please contact the merchant directly for further information.
					</>
				),
			},
			{
				title: 'My order got cancelled by the merchant, how will I receive my refund?',
				content: (
					<>
						In case your order is cancelled by the merchant, your transaction amount will be refunded to your payment
						mode. This may take up to 5 working days from date of refund initiation by the merchant.
					</>
				),
			},
			{
				title: 'I have an issue related to the order/transaction I made on the bharatpe app. Can bharatpe help?',
				content: (
					<>
						You can reach out on <Url url="mailto:help@postpe.app" alternateText="help@postpe.app" /> or{' '}
						<Url url="mailto:care@magicpin.in" alternateText="care@magicpin.in" /> for queries on order status and
						delivery.
					</>
				),
			},
			{
				title: 'I ordered the wrong food item by mistake. Can I change this?',
				content: (
					<>
						Orders once placed cannot be changed. For orders placed on ONDC, returns and replacements are not permitted.{' '}
						<br />
						In case of any issues with your order, please reach out on{' '}
						<Url url="mailto:help@postpe.app" alternateText="help@postpe.app" /> or{' '}
						<Url url="mailto:care@magicpin.in" alternateText="care@magicpin.in" /> for resolution.
					</>
				),
			},
			{
				title: 'Can I use my bharatpe limit to place an order on ONDC?',
				content: <>You can place an order on ONDC from the bharatpe app using UPI payment mode only.</>,
			},
		],
	},
	'Loan ABFL': {
		img: InfoImg,
		faqs: [
			{
				title: 'What are the benefits of availing a personal loan through Aditya Birla Finance Limited?',
				content: (
					<p className="mr-t-5">
						Aditya Birla Finance Limited, a RBI-registered Non-Banking Financial Company (NBFC) offers a personal loan
						allowing you to borrow up to INR 5 lakhs. Key features include: <br />
						• Low-interest rates <br />
						• No collateral or security required <br />
						• Tenure: 12 - 36 months <br />
					</p>
				),
			},
			{
				title: `Who provides the loan?`,
				content: (
					<p className="mr-t-5">
						Aditya Birla Finance Limited is an RBI-registered NBFC which will provide short-term loans. postpe merely
						facilitates the process of availing a personal loan through the NBFC partner.
					</p>
				),
			},
			{
				title: `Who do I contact for any queries or grievances?`,
				content: (
					<p className="mr-t-5">
						If you have any concerns or inquiries regarding your loan, please feel free to get in touch with Aditya
						Birla Finance Limited. You can contact them by emailing grievance.finance@adityabirlacapital.com, mentioning
						your loan ID for efficient assistance.
					</p>
				),
			},
			{
				title: `How can I repay my personal loan?`,
				content: (
					<p className="mr-t-5">
						Repayments for your personal loan should be made directly to Aditya Birla Finance Limited or others as
						prescribed during the repayment stage. It's important to be aware that, postpe does not support repayments
						for loans obtained from ABFL.
					</p>
				),
			},
			{
				title: `How do I get my loan statements, repayment schedule and pre-closure projection?`,
				content: (
					<p className="mr-t-5">
						All details concerning your loan transaction will be accessible through ABFL. For additional information or
						assistance, please don’t hesitate to contact the support team at ABFL via
						care.finance@adityabirlacapital.com or call at 1800 270 7000.
					</p>
				),
			},
			{
				title: `Does postpe charge any commission from customer for directing the customer to ABFL for seeking “Personal Loan”?`,
				content: (
					<p className="mr-t-5">
						Does postpe charge any commission from customer for directing the customer to ABFL for seeking “Personal
						Loan”?
					</p>
				),
			},
			{
				title: `Does postpe guarantee delivery of Personal Loan, if applied through postpe?`,
				content: (
					<p className="mr-t-5">
						No, the Terms & Conditions for availing personal loans remains the same as mentioned by ABFL at the time of
						application and postpe does not guarantee any kind of delivery of a personal loan, even if applied via
						postpe. Selection/Rejection of a customer is solely based on decisions made by ABFL, and postpe has no
						involvement therein, whatsoever.
					</p>
				),
			},
		],
	},
});

export default faqs;
